import AppBar from '../../components/appBar';
import Page from '../../components/page';
import { useState } from 'react';
import Face from './components/face';
import Certification from './components/certification';
import FacingPhoto from './components/facingPhoto';
import ReverseSidePhoto from './components/reverseSidePhoto';
import { useNavigate } from 'react-router-dom';
import VideoLoading from './components/videoLoading';


export default function UserAuthentication() {

  const [active, setactive] = useState(1);
  const navigate = useNavigate();

  function handleCancel(e: boolean, goBack?: boolean) {
    if (!e) {
      return setactive(1)
    }
    if (goBack) {
      return navigate(-1)
    }
    setactive(active + 1)
  }
  return (
    <Page className="d-flex-c" contentClassName="flex-1 d-flex-c overflow-y " appBar={<AppBar title="用户认证" />}>
      {active === 1 && <Certification onCancel={(e) => handleCancel(e)} />}
      {active === 2 && <FacingPhoto onCancel={(e) => handleCancel(e)} />}
      {active === 3 && <ReverseSidePhoto onCancel={(e) => handleCancel(e)} />}
      {active === 4 && <VideoLoading onCancel={(e) => handleCancel(e)} />}
      {active === 5 && <Face onCancel={(e) => handleCancel(e, true)} showBlob={true} shoDownloadVideo={true}/>}
    </Page>
  );
}
